import type {Editor} from 'tinymce';

const getRetainStyleProps = (editor: Editor): string | undefined =>
    editor.options.get('paste_retain_word_style_properties');

const shouldConvertWordFakeLists = (editor: Editor): boolean =>
    editor.options.get('paste_convert_word_fake_lists');

const getValidate = (editor: Editor): boolean | undefined =>
    editor.options.get('validate');

export {
    getRetainStyleProps,
    shouldConvertWordFakeLists,
    getValidate,
};
